export enum ReportTypes {
  RegularStudent = 'regular-student',
  EnrolledStudent = 'enrolled-student',
  GradesStudent = 'grades-student',
  DegreeStudent = 'degree-student',
  TitledStudent = 'titled-student',
  CurriculumStudent = 'pdi-curriculum-student',
  PdiAcademicProgressStudent = 'pdi-academic-progress-student',
  PdiGradesStudent = 'pdi-grades-student',
  PdiTitledOpplStudent = 'pdi-titled-oppl-student',
  PdiTitledOppStudent = 'pdi-titled-opp-student',
  CeStudentCertificateSingle = 'ce-student-certificate-single',
}

export type ReportType = `${ReportTypes}` | string;

export interface CertificateType {
  id: number;
  code: ReportType;
  name: string;
  description: string;
  dynamicFormId?: number;
  paymentRequired?: boolean;
  paymentAmount?: string;
  createdAt: Date;
  updatedAt: Date;
}

export type PaymentMethod = 'gateway' | 'iceberg' | null;
export type PaymentStatus = 'not_required' | 'pending_payment' | 'paid';

export interface MyCertificate {
  id: string;
  createdAt: string;
  paymentStatus: PaymentStatus;
  paymentMethod: PaymentMethod;
  paidAt: string | null;
  certificateType: {
    id: number;
    name: string;
    code: string;
    paymentRequired: boolean;
    paymentAmount: string;
  } | null;
}
